import { currentUserQueryOptions } from '@/utils/fetchers/user'
import queryClient from '@/utils/queryClient'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(legacy)/me')({
	loader: async () => {
		const { username } = await queryClient.ensureQueryData(currentUserQueryOptions)
		throw redirect({
			to: '/u/$username',
			replace: true,
			params: {
				username,
			},
		})
	},
})
